// extracted by mini-css-extract-plugin
module.exports = {"iframe":"IframePlayer_iframe__2ZPNy","no-border-radius":"IframePlayer_no-border-radius__3x1cG","post-show":"IframePlayer_post-show__33z-u"};